import { Component } from '@angular/core';
import { OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertsService } from '../../services/alerts.service';
import { AlbumsService } from '../../services/albums.service';
import { UserService } from '../../services/user.service';

/**
 * Component for updating an individual album.
 */
@Component({
	selector: 'album',
	templateUrl: './album.component.html',
	styleUrl: './album.component.css'
})
export class AlbumComponent implements OnInit {
	@Input() album: any;

	LOCALIZATION: any;

	isUpdate: boolean = false;
	input = {
		albumname: '',
		description: ''
	};
	limits = {
		description: 500,
		albumname: 255
	};

	constructor(
		private userService: UserService,
		private alertsService: AlertsService,
		private albumsService: AlbumsService,
		private ngbmodalService: NgbActiveModal
	) { }

	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;
		this.initValues();
	}

	private initValues(): void {
		if (this.album.id) {
			this.isUpdate = true;
			this.input.albumname = this.album.name;
			this.input.description = this.album.description || '';
		}
	}

	/**
	 * Saves the album data.
	 */
	save(): void {
		if (this.isUpdate) {
			this.albumsService.renameAlbum(this.album.id, this.input.albumname, this.input.description).then(
				(response: any) => {
					this.alertsService.success({
						message: "The album was updated."
					});
					this.proceed();
				},
				(err: any) => {
					console.error("Failed to update album", err);
					this.alertsService.error({
						message: "Could not update the album."
					});
				}
			);
		} else {
			this.albumsService.addAlbum(this.input.albumname, this.input.description).then(
				(response: any) => {
					this.alertsService.success({
						message: "The album was created. You can now start adding items to album."
					});
					this.proceed();
				},
				(err: any) => {
					console.error("Failed to add album", err);
					this.alertsService.error({
						message: "Could not create the album."
					});
				}
			);
		}
	}

	/**
	 * Closes the modal, returning a result of ok and payload.
	 */
	proceed(): void {
		let caller = {
			callerName: 'updateAlbum'
		};

		this.ngbmodalService.close({
			result: { answer: 'ok', caller: caller },
			timestamp: new Date(),
		});
	}

	/**
	 * Closes the modal.
	 */
	close(): void {
		this.ngbmodalService.dismiss();
	}
}
